<template>
  <div>
    <Guia :showGuia="showGuia" :consulta="consulta"/>
    <Lote :showLote="showLote" :parent="this"/>

    <TableView
      registerName="Nova Consulta"
      :onRegister="onRegister"
      :onSearch="getConsulta"
      :onFilter="getConsulta"
      :onEdit="onEdit"
      :onDelete="onDelete"
      :tableData="tableData"
      :tableHead="tableHead"
      :pagination="pagination"
      :response="response"
      :filterBadge="filterBadge"
      :loadingTable="config.loading.table"
    >
      <div slot="table-button">
				<ed-button
					icon="fa fa-copy"
					type="success"
					value="Gerar Consulta em Lote"
          title="Clique aqui para gerar várias consultas ao mesmo tempo."
          @click="onLote"
				/>
			</div>

      <div slot="table-filter-content">
				<ed-form 
					:data="formFilter" 
					:config="config" 
					:response="response" 
					:itens="filterItems"
				/>
			</div>
    </TableView>
  </div>
</template>

<script>

import Rest from "common/rest";
import EdForm from "common/form";
import EdButton from "common/button";
import TableView from 'common/table'
import Guia from 'appsEmpresa/consulta/_includes/guia'
import Lote from 'appsEmpresa/consulta/_includes/lote'
import FilterItems from './_form/consulta-filtro'

export default {
  components: {TableView,Guia,Lote,EdForm,EdButton},
  mixins: [Rest],
  data() {
    return {
      config:{
        tipo:[46,53],
        tipo_exclude:[68,70],
        click:{
          id_cre:this.getCredenciada,
          id_funcionario:this.getFuncionario,
        },
        list:{
          id_cre:[],
          id_funcionario:[],
        },
        loading:{
          id_cre:false,
          id_funcionario:false,
          table:false,
        },
        disabled:{
          id_funcionario:false,
          id_fdt:true,
        }
      },
      formFilter:{
        id_cre:null,
        id_funcionario: null,
        id_tipo_status: [],
        id_tipo_aso: [],
        created_at:[],
        agendamento_at:[],
        deleted:0
      },
      filterBadge:0,
      loadingTable:false,
      showGuia:false,
      showLote:false,
      consulta:null,
      pagination:{},
      response:{},
      tableData: [],
      filterItems:[],
      tableHead: [
          {
            key: 'id_con',
            sortable: true,
            label: 'Consulta',

          },
          {
            key: 'credenciada',
            sortable: true,
            label: 'Credenciada',

          },
          {
            key: 'funcionario',
            sortable: true,
            label: 'Funcionário',
          },
          {
            key: 'funcao',
            sortable: true,
            show_tipo_aso:true,
            label: 'Função',
          },
          {
            key: 'data_age',
            sortable: true,
            label: 'Agendamento',
          },
          {
            key: 'status',
            show_status:true,
            sortable: true,
            label: 'Status',
          }
      ]
    };
  },
  beforeDestroy(){
		this.tableData = [];
	},
  created() {
  },

  mounted(){
    this.getConsulta();
    this.getCredenciada();
    this.getFuncionario();

    this.filterItems = FilterItems;
  },

  methods: {

    onRegister(){
      this.toRoute({name:'empresa.consulta.cad'})
    },

    onEdit(data){
      this.toRoute({name: 'empresa.consulta.edt',params:{consulta:data.id}});
    }, 
    
    onDelete(data){
      
      var self = this;

      this.$confirm('O sistema vai excluir '+data.length+' registro(s). Deseja prosseguir?', 'Atenção', {
          type: 'warning'

      }).then(() => {

        self.response = {};
        self.loadingTable = true;

        self.delete('consulta/externa/deletar',{itens:data}).then((result) =>{
          result = result[0];

          self.loadingTable = false;
          self.response = result;
          self.getConsulta();

          if(result.status == 200){
            this.edMsg('Registro(s) excluído(s) com sucesso');
            self.getFuncionario();
          }
        });
      });
    }, 

    onGuia(data){
      this.consulta = data;
      this.showGuia = !this.showGuia;
    },

    onLote(){
      this.showLote = !this.showLote;
    },

     getCredenciada: function(_search){

      this.config.loading.id_cre = true;
      this.config.list.id_cre = [];

      this.get('/credenciada',{search:_search}).then((result)=>{

        result = result[0];

        this.config.loading.id_cre = false;

        if(result.status == 200){
          this.config.list.id_cre = result.data.data;
        }
      });

    },

    getFuncionario: function(_search){

      this.config.loading.id_funcionario = true;
      this.config.list.id_funcionario = [];

      this.get('/funcionario/0',{search:_search}).then((result)=>{

        result = result[0];

        this.config.loading.id_funcionario = false;

        if(result.status == 200){
          this.config.list.id_funcionario = result.data.data;
        }
      });

    },

    getConsulta(search,page,pagination) {
    
    this.config.loading.table = true;

    if(!this.formFilter.agendamento_at){
      this.formFilter.agendamento_at = [];
    }

    if(!this.formFilter.created_at){
      this.formFilter.created_at = [];
    }

    if(this.formFilter.agendamento_at.length != 2){
      var
      hoje = this.toDate(null,true),
      ontem = this.toDate(this.addDate(-60,null,'D'),true),
      amanha = this.toDate(this.addDate(0,null,'D'),true);

      this.formFilter.agendamento_at = [ontem,amanha];
    }

    this.filterBadge = (
      (this.formFilter.id_funcionario ? 1 : 0)+
      (this.formFilter.id_cre ? 1 : 0)+
      (this.formFilter.created_at.length>0 ? 1 : 0)+
      (this.formFilter.agendamento_at.length>0 ? 1 : 0)+
      (this.formFilter.id_tipo_aso.length)+
      (this.formFilter.id_tipo_status.length)
    );

		this.get("consulta/externa",{search:search,page:page,pagination:pagination,filter:this.formFilter}).then(result => {
      result = result[0];
      
      this.config.loading.table = false;
      this.response = result;

      var data = [], tableData = [], pagination = {};

			if(result.status == 200) {

        data = result.data.data;
 
        for (var i = 0; i < data.length; i++) {

          var item = {
            id: data[i].id,
            id_con: (data[i].id_con ? data[i].id_con : '---'),
            credenciada: (data[i].credenciada ? data[i].credenciada.nome : null),
            funcionario: (data[i].funcionario ? data[i].funcionario.nome : null),
            funcao: (data[i].funcao ? data[i].funcao.nome : null),
            ghe: (data[i].ghe ? data[i].ghe.ghe+' ('+data[i].ghe.descricao+')' : null),
            tipo_consulta: (data[i].tipo_aso ? data[i].tipo_aso.descricao : null),
            status: (data[i].info),
            data_age: this.toDate(data[i].data_age,true),
            _data: data[i],
            options:{
              disable_edit: (data[i].deleted_at ? true : false),
              disable_delete: (data[i].id_con || data[i].deleted_at ? true : false),
            },
            buttons : []
          };
          
          
          if(!data[i].deleted_at && data[i].tipo_status.id != 57 && data[i].tipo_status.id != 58){
            item.buttons.push({
              color: 'info',
              icon : 'fa fa-file-pdf-o',
              title: 'Abrir Guia de Encaminhamento',
              click : this.onGuia
            })
          }
          tableData.push(item);
        }

        pagination = result.data;
      } 
      
       this.tableData = tableData;
       this.pagination = pagination;
		});
    },
  }
};
</script>



// WEBPACK FOOTER //
// index.vue?ae51405c